import { DEFAULT_LABEL_WIDTH } from "definitions/constants/styling";

export const shortAttributeStyles = {
  labelContainerProps: { minWidth: "20", maxWidth: "20" },
};

export const longAttributeStyles = {
  labelContainerProps: { minWidth: DEFAULT_LABEL_WIDTH, maxWidth: DEFAULT_LABEL_WIDTH },
};
